<template>
  <NuxtLink
    :active-class="
      highlightActive
        ? darkOnActive
          ? 'font-bold text-black'
          : 'font-bold text-white'
        : ''
    "
    class="whitespace-no-wrap leading-5 tracking-wide transition duration-200 ease-linear"
    :to="to"
    :class="{
      'text-gray-700': type === 'whisper',
      uppercase: type === 'loud',
      'font-bold uppercase': type === 'extra-loud',
      'hover:underline': hover === 'underline',
      'hover:text-shadow': hover === 'bold',
      [`text-${size}`]: size,
      'inline-flex items-center gap-2': !inParagraph,
    }"
  >
    <span v-if="icon || badge || $slots.icon || $slots.badge" class="relative">
      <slot name="icon" />
      <Icon v-if="icon" :icon="icon" :size="iconSize" />
      <slot v-if="badge" name="badge" :badge="badge">
        <Transition
          enter-from-class="opacity-0"
          enter-active-class="transition-all duration-200 ease-linear"
          enter-to-class="opacity-100"
          leave-active-class="transition-all duration-200 ease-linear"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <LinkBadge :data-badge-content="badge">{{ badge }}</LinkBadge>
        </Transition>
      </slot>
    </span>
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
defineProps({
  to: {
    type: [String, Object] as PropType<string | object>,
    required: true,
  },
  icon: {
    type: String as PropType<string>,
    default: '',
  },
  badge: {
    type: [Number, String] as PropType<number | string>,
    default: undefined,
  },
  onlyExactActive: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  highlightActive: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  darkOnActive: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  hover: {
    type: String as PropType<string>,
    default: 'bold',
    validator: (val: string) => ['bold', 'underline'].includes(val),
  },
  type: {
    type: String,
    default: 'default',
    validator: (val: string) =>
      ['default', 'loud', 'extra-loud', 'whisper'].includes(val),
  },
  size: {
    type: String as PropType<string>,
    default: 'xs',
    validator: (val: string) => ['lg', 'sm', 'xs', 'base'].includes(val),
  },
  iconSize: {
    type: String as PropType<string>,
    default: '4',
  },
  inParagraph: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})
</script>
